import React from "react";
import CrackedCodeSlider from "../Frontend/Sliders/CrackedCodeSlider";
import ButtonComp from "./ButtonComp";
import NewCustomSlider from "./NewCustomSlider";
import ReactHtmlParser from "react-html-parser";

const TestimonialSection = ({
  title,
  subtitle,
  extraClass = "",
  extraWidth = "",
  btnText,
  btnLink = "/auth/register",
  onBtnClick,
  showBtn = true,
  sliderList,
  titleClass=""
}) => {
  const isOnlyTitle = !subtitle && !showBtn;
  return (
    <div className="sss-section testimonial-section custom-container">
      {/* Header: Title left, Subtitle + Button right */}
      <div className="custom-container">
        <div
          className={`testimonial-section__header ${extraClass} ${
            isOnlyTitle ? "only-title" : ""
          }`}
        >
          <h3
            className={`testimonial-section__title FS40FW600 ${titleClass} `}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {!isOnlyTitle && (
            <div className="testimonial-section__right " style={{ maxWidth: extraWidth }}>
              {subtitle && (
                <p className="testimonial-section__subtitle quote-para FS16FW500">
                  {ReactHtmlParser(subtitle)}
                </p>
              )}

              {showBtn &&
                btnText &&
                (onBtnClick ? (
                  <button className="primary-btn" onClick={onBtnClick}>
                    {btnText}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="CTA"
                    />
                  </button>
                ) : (
                  <ButtonComp btnText={btnText} link={btnLink} />
                ))}
            </div>
          )}
        </div>
      </div>

      {/* Slick Carousel Cards */}
      {/* <CrackedCodeSlider /> */}
      <NewCustomSlider data={sliderList} />
    </div>
  );
};

export default TestimonialSection;
